export default __webpack_public_path__ + "i18n/translations/translation-te.cb87a5f0.json";